export function waitMillis(millis: number): Promise<void> {
    return new Promise<void>((res) => {
        setTimeout(res, millis);
    });
}
